import { SVGProps } from 'react';

function FileUploadIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="56" height="55" viewBox="0 0 56 55" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_37937_70914)">
        <path
          d="M34.875 39.5078H43.0391C48.9473 39.5078 53.7812 36.37 53.7812 30.5273C53.7812 24.6847 48.0879 21.7757 43.4688 21.5469C42.5138 12.4096 35.8418 6.85156 28 6.85156C20.5879 6.85156 15.8141 11.7704 14.25 16.6484C7.80469 17.2607 2.21875 21.3621 2.21875 28.0781C2.21875 34.7941 8.01953 39.5078 15.1094 39.5078H21.125"
          stroke="#424242"
          strokeWidth="3.4375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.875 27.4766L28 20.6016L21.125 27.4766M28 48.1467V22.3203"
          stroke="#424242"
          strokeWidth="3.4375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_37937_70914">
          <rect width="55" height="55" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FileUploadIcon;
